import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Fetch Tattoo
export const fetchTattooThunk = createAsyncThunk(
  "fetchTattoo",
  async (tattoo, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/tattoos/fetchDetail/${tattoo.id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching tattoo");
    }
  }
);

// Fetch Tattoos
export const fetchTattoosThunk = createAsyncThunk(
  "fetchTattoos",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/tattoos/fetchAll`,
        params
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching tattoos");
    }
  }
);

// Create Tattoo
export const createTattoosThunk = createAsyncThunk(
  "createTattoos",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/tattoos/admin/create`,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error creating tattoo");
    }
  }
);

// Update Tattoo
export const updateTattooThunk = createAsyncThunk(
  "updateTattoo",
  async ({ id, values }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/tattoos/update/${id}`,
        values
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating tattoo");
    }
  }
);

// Delete Tattoo
export const deleteTattooThunk = createAsyncThunk(
  "deleteTattoo",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/tattoos/delete/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error deleting tattoo");
    }
  }
);

// Update Tattoo Order
export const updateTattoosPositionThunk = createAsyncThunk(
  "updateTattoosPosition",
  async ({ position }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/tattoos/shuffleData`,
        { id: position }  // Ensuring correct API parameter
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating order");
    }
  }
);

export const sortTattoosThunk=createAsyncThunk(
  "sortTattoos",
  async ({ id,isSorted }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL_LOCAL}/api/tattoos/sort`,
        { id,isSorted }  // Ensuring correct API parameter
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error updating order");
    }
  }
)

export const tattoosSlice = createSlice({
  name: "tattoos",
  initialState: {
    tattoos: [],
    total: 0,
    limit: 10,
    page: 1,
    pageCount: 0,
    isLoading: true,
  },
  reducers: {
    changeLimit: (state, action) => {
      state.limit = action.payload;
    },
    changePage: (state, action) => {
      state.page = action.payload;
    },
    updateOrder: (state, action) => {
      state.tattoos = action.payload; // Update state immediately on drag
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTattoosThunk.fulfilled, (state, action) => {
        state.tattoos = action?.payload?.data?.tattoos;
        state.total = action?.payload?.data?.totalCount;
        state.page = action?.payload?.data?.currentPage;
        state.pageCount = action?.payload?.data?.totalPages;
        state.isLoading = false;
      })
      .addCase(updateTattoosPositionThunk.fulfilled, (state, action) => {
        // If needed, update the local state with reordered tattoos
      })
      .addCase(updateTattoosPositionThunk.rejected, (state, action) => {
        console.error("Failed to update order:", action.payload);
      });
  },
});

// Export actions
export const { changeLimit, changePage, updateOrder } = tattoosSlice.actions;
export default tattoosSlice.reducer;
